import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FormStep, OrderDataType } from "types/order/OrderDataType";
import {
  getConfigParamThunk,
  getCourierThunk,
  newOrderThunk,
} from "./order.actions";
import { showToast } from "utils/helpers/toastHelper";

export type OrderType = {
  first_name: string; //Ime
  last_name: string; // Prezime
  telephone: string; //Broj telefona
  email: string; // Email adresa
  person: "fizicko_lice" | "pravno_lice";
  company_name: string | undefined; //Naziv firme - ukoliko je pravno lice
  receiving_way: "na_adresu_infocompa" | "na_kucnu_adresu";
  store: string | undefined; //Izabrati prodavnicu ako je u prodavnici
  state: string | undefined; //Drzava / Region - default Bosna i Hercegovina
  city: string | undefined; //Grad
  zip: string | undefined; //Poštanski broj
  address: string | undefined; //Ulica i broj
  address_addition: string | undefined; //dodatne informacije: Stan, apartman, sprat, itd.
  method_of_payment: "placanje_prilikom_preuzimanja" | "placanje_karticom";
  //todo informacije o kartici - adresa racuna
  //info o ceni i pdf-u
  //informacije o isporuci prikazati i sadržaj korpe
  description: string | undefined; //dodatna napomena u porudzbini
  agreement: boolean; //slaganje  sa uslovima korišćenja i odredbama
  promo_code: string | undefined;
  courier_id: number | undefined;
};

export const orderDataInitialState: OrderType = {
  first_name: "",
  last_name: "",
  telephone: "",
  email: "",
  person: "fizicko_lice",
  company_name: undefined,
  receiving_way: "na_adresu_infocompa",
  store: "",
  state: "Bosna i Hercegovina",
  city: "",
  zip: "",
  address: "",
  address_addition: "",
  method_of_payment: "placanje_prilikom_preuzimanja",
  description: "",
  agreement: false,
  promo_code: "",
  courier_id: 1,
};
export const orderInitialState = {
  is_loading: false,
  error: false,
  data: orderDataInitialState,
  config_param: NaN,
  couriers: [],
  finishedOrder: {},
};
export const newOrder = createAsyncThunk("order/newOrder", newOrderThunk);
export const getConfigParam = createAsyncThunk(
  "order/getConfigParam",
  getConfigParamThunk
);
export const getCourier = createAsyncThunk("order/getCourier", getCourierThunk);

const OrderSlice = createSlice({
  name: "order",
  initialState: orderInitialState,
  reducers: {
    updateOrder: (state, { payload }) => {
      return { ...state, data: payload };
    },
    resetOrder: (state) => {
      state.data = orderDataInitialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(newOrder.fulfilled, (state, { payload }) => {
        showToast(`Uspiješno ste poručili`, "success");
        return {
          ...state,
          is_loading: false,
          data: orderDataInitialState,
          finishedOrder: payload,
        };
      })
      .addCase(newOrder.pending, (state) => {
        return { ...state, is_loading: true };
      })
      .addCase(newOrder.rejected, (state) => {
        showToast(
          "Greska prilikom kreiranja narudzbine! Pokušajte ponovo.",
          "error"
        );
        // return { ...state, is_loading: false, user_details: userDetails };
        return { ...state, error: true, is_loading: false };
      })
      .addCase(getConfigParam.fulfilled, (state, { payload }) => {
        return { ...state, config_param: Number(payload) };
      })
      .addCase(getConfigParam.rejected, (state) => {
        return { ...state, config_param: NaN };
      })
      .addCase(getCourier.fulfilled, (state, { payload }) => {
        return { ...state, couriers: payload };
      })
      .addCase(getCourier.rejected, (state) => {
        return { ...state, couriers: [] };
      });
  },
});

export const { updateOrder, resetOrder } = OrderSlice.actions;
export default OrderSlice.reducer;
